import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { UtilService } from '../../services/util.service';
import { CommonModule } from '@angular/common';

type errorFn = (...args: any) => string;
export type ErrorMessagesConfig = { [key: string]: errorFn };

const defaultErrorMessagesConfig: ErrorMessagesConfig = {
  min: (error: { min: number, actual: number }) => `The min value for this field is ${ error.min }`,
  max: (error: { max: number, actual: number }) => `The max value for this field is ${ error.max }`,
  minlength: (error: { requiredLength: number, actualLength: number }) =>
    `The min length of the field is ${error.requiredLength} characters`,
  maxlength: (error: { requiredLength: number, actualLength: number }) =>
    `The max length of the field is ${error.requiredLength} characters`,
  pattern: (error: { requiredPattern: string, actualValue: string }) =>
    `The field should fit a pattern: ${ error.requiredPattern }`,
  required: () => `This field is required`,
  requiredTrue: () => `This field is required`,
  email: () => `This field should be a valid email`,
  valuesMustBeDifferent: () => 'Value must be different',
};

@Component({
    selector: 'fk-form-control',
    templateUrl: './form-control.component.html',
    styleUrls: ['./form-control.component.scss'],
    imports: [CommonModule],
})
export class FormControlComponent implements OnChanges {
  @Input()
  public label!: string;

  @Input()
  public control!: AbstractControl;

  @Input()
  public hideErrors = false;

  @Input()
  public errorMessagesConfig: ErrorMessagesConfig | null = null;

  protected id!: string;

  private _errorMessagesConfig: ErrorMessagesConfig = {
    ...defaultErrorMessagesConfig,
  };

  protected get errors(): ValidationErrors | null {
    return this.control?.errors;
  }

  protected get errorMessages(): ErrorMessagesConfig {
    return this._errorMessagesConfig;
  }

  constructor() {
    this.id = `fk-form-control-${UtilService.getRandId()}`;
  }

  public ngOnChanges(changes: SimpleChanges) {
    const errorMessagesConfigChanges = changes['errorMessagesConfig'];

    if (errorMessagesConfigChanges) {
      this._errorMessagesConfig = {
        ...defaultErrorMessagesConfig,
        ...errorMessagesConfigChanges.currentValue,
      };
    }
  }
}
